import { Redirect } from "react-router";
import Staff from "../pages/staff/staff.js";
import UpdatePassword from "../pages/staff/changePassword.js";
import CreateStaff from "../pages/staff/createStaff.js";
import UpdateStaff from "../pages/staff/UpdateStaff.js";
import PondNote from "../pages/pondNote/pondNote.js";
import PondDetail from "../pages/pondDetail/pondDetail.js";
import Pond from "../pages/pond/pond.js";
import Sampling from "../pages/sampling/sampling.js";
import FishTypes from "../pages/fishTypes/fishTypes.js";
import Accounts from "../pages/staff/accounts.js";
import Scientists from "../pages/staff/scientists.js";
import UpdateScientist from "../pages/staff/UpdateScientist.js";
import WeightUnits from "../pages/units/weightUnits.js";
import LengthUnits from "../pages/units/lengthUnits.js";
import PondDetailViaPond from "../pages/pondDetail/pondDetailViaPond.js";
import PondFishesViaPondDetail from "../pages/pondFishes/pondFishesViaPondDetail.js";
import SamplingDetailViaPondDetail from "../pages/sampling/SamplingDetailViaPondDetail.js";
import SamplingGalleryViaPondDetail from "../pages/sampling/SamplingGalleryViaPondDetail.js";
import AddSamplingDetail from "../pages/sampling/AddsamplingDetail.js";
import PondNoteViaPondDetail from "../pages/pondNote/pondNoteviaPondDetail.js";
import ManagePackages from "../pages/package/package.js";
import ManageCoupons from "../pages/coupon/coupons.js";
import UpdateFisher from "../pages/staff/UpdateFisher.js";
import FishDataTableView from "../pages/sampling/TableView.jsx";
import FishDataGraphView from "../pages/sampling/graphView/FishDataGraphView.jsx";
import FishDataGraphViewV2 from "../pages/sampling/graphViewV2/FishDataGraphViewV2.jsx";
import UpdatePond from "../pages/pond/updatePond.js";
import CreatePond from "../pages/pond/createPond.js";
import PondFeedFertilization from "../pages/pond/pondFeedFertilization.js";
import StockingData from "../pages/pond/stockingData.js";
import CreatePondDetail from "../pages/pondDetail/CreadPD.js";
import UpdatePD from "../pages/pondDetail/UpdatePD.js";
import Dashboard from "../pages/dashboard/dashboard.js";
import Companies from "../pages/company/companies.js";

const routes = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  {
    path: "/dashboard",
    title: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/pond",
    title: "Pond",
    component: Pond,
  },
  {
    path: "/createPond",
    title: "Create Pond",
    component: CreatePond,
  },
  {
    path: "/updatePond/:id",
    title: "Update Pond",
    component: UpdatePond,
  },
  {
    path: "/pondFeedFertilization/:id",
    title: "Feed & Fertilization",
    component: PondFeedFertilization,
  },
  {
    path: "/pondStocking/:id",
    title: "Stocking Data",
    component: StockingData,
  },
  {
    path: "/fishingData",
    title: "Fishing/Sampling Data",
    component: PondDetail,
  },
  {
    path: "/FishDataTableView/:id",
    title: "Fish Data Table",
    component: FishDataTableView,
  },
  {
    path: "/FishDataTableView",
    exact: true,
    title: "Fish Data Table",
    component: FishDataTableView,
  },
  {
    path: "/fish-data-graph/:pondDetailId",
    title: "Fish Data Graph",
    component: FishDataGraphView,
  },
  {
    path: "/fish-data-graph",
    exact: true,
    title: "Fish Data Graph",
    component: FishDataGraphView,
  },
  {
    path: "/fish-data-graph-new/:pondDetailId",
    title: "Fish Data Graph",
    component: FishDataGraphViewV2,
  },
  {
    path: "/fish-data-graph-new",
    exact: true,
    title: "Fish Data Graph",
    component: FishDataGraphViewV2,
  },
  {
    path: "/FishDataGraphView/:id",
    component: ({ match }) => <Redirect to={`/fish-data-graph/${match.params.id}`} />,
  },
  {
    path: "/FishDataGraphView",
    exact: true,
    component: () => <Redirect to="/fish-data-graph-new" />,
  },
  {
    path: "/changePassword/:id",
    title: "Change Password",
    component: UpdatePassword,
  },
  {
    path: "/sampling",
    title: "Sampling",
    component: Sampling,
  },
  {
    path: "/fishTypes",
    title: "Fish Types",
    component: FishTypes,
  },
  {
    path: "/pondNote",
    title: "Pond Notes",
    component: PondNote,
  },
  {
    path: "/staff/:id",
    title: "Users",
    component: Staff,
  },
  {
    path: "/scientists",
    title: "Scientists",
    component: Scientists,
  },
  {
    path: "/UpdateScientist/:id",
    title: "Update Scientist",
    component: UpdateScientist,
  },
  {
    path: "/companies",
    title: "Companies",
    component: Companies,
  },
  {
    path: "/accounts",
    title: "Accounts",
    component: Accounts,
  },
  {
    path: "/createStaff",
    title: "Create Staff",
    component: CreateStaff,
  },
  {
    path: "/units/weightUnits",
    title: "Weight Units",
    component: WeightUnits,
  },
  {
    path: "/units/lengthUnits",
    title: "Length Units",
    component: LengthUnits,
  },
  {
    path: "/UpdateStaff/:id",
    title: "Update Staff",
    component: UpdateStaff,
  },
  {
    path: "/pondDetail",
    title: "Pond Detail",
    component: () => <Redirect to="/fishingData" />,
  },
  {
    path: "/createpd",
    title: "Create Pond Detail",
    component: CreatePondDetail,
  },
  {
    path: "/createpd/:id",
    title: "Create Pond Detail",
    component: CreatePondDetail,
  },
  {
    path: "/UpdatePD/:id",
    title: "Update Pond Detail",
    component: UpdatePD,
  },
  {
    path: "/pondDetailOverview/:id",
    component: ({ match }) => <Redirect to={`/UpdatePD/${match.params.id}`} />,
  },
  {
    path: "/Updatepd/:id",
    component: ({ match }) => <Redirect to={`/pondDetailOverview/${match.params.id}`} />,
  },
  {
    path: "/pondDetailViaPond/:id",
    title: "Pond Detail Via Pond",
    component: PondDetailViaPond,
  },
  {
    path: "/samplingViaPondDetail/:id",
    title: "Sampling Via Pond Detail",
    component: SamplingDetailViaPondDetail,
  },
  {
    path: "/samplingGalleryViaPondDetail/:id",
    title: "Sampling Gallery",
    component: SamplingGalleryViaPondDetail,
  },
  {
    path: "/AddSamplingDetail/:id",
    title: "Add Sampling Detail",
    component: AddSamplingDetail,
  },
  {
    path: "/pondFishViaPondDetail/:id",
    title: "Fish Via Pond Detail",
    component: PondFishesViaPondDetail,
  },
  {
    path: "/pondNoteViaPondDetail/:id",
    title: "Notes Via Pond Detail",
    component: PondNoteViaPondDetail,
  },
  {
    path: "/packages",
    title: "Packages",
    component: ManagePackages,
  },
  {
    path: "/coupons",
    title: "Coupons",
    component: ManageCoupons,
  },
  {
    path: "/updateFisher/:id",
    title: "Update Fisher",
    component: UpdateFisher,
  },
];

export default routes;
